import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'mevi-form-autosave';
const SAVE_DELAY = 2000; // 2 seconds debounce

export const useAutoSave = (data, enabled = true) => {
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (!enabled || !data) return;

        // Clear existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Debounce save
        timeoutRef.current = setTimeout(() => {
            try {
                const saveData = {
                    timestamp: new Date().toISOString(),
                    data: data,
                };
                localStorage.setItem(STORAGE_KEY, JSON.stringify(saveData));
            } catch (error) {
                console.error('Auto-save failed:', error);
            }
        }, SAVE_DELAY);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [data, enabled]);

    // Save on window close
    useEffect(() => {
        const handleBeforeUnload = () => {
            if (enabled && data) {
                try {
                    const saveData = {
                        timestamp: new Date().toISOString(),
                        data: data,
                    };
                    localStorage.setItem(STORAGE_KEY, JSON.stringify(saveData));
                } catch (error) {
                    console.error('Save on close failed:', error);
                }
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [data, enabled]);
};

export const loadAutoSave = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (!saved) return null;

        const { timestamp, data } = JSON.parse(saved);
        return { timestamp, data };
    } catch (error) {
        console.error('Load auto-save failed:', error);
        return null;
    }
};

export const clearAutoSave = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        console.log('Auto-save cleared');
    } catch (error) {
        console.error('Clear auto-save failed:', error);
    }
};
